const GlobeIcon = ({ className, onClick, width = 16, height = 16 }) => (
  <svg
    width={width}
    className={className}
    onClick={onClick}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21.5" cy="20" r="20" fill="#CEFBFA" />
    <path d="M17.5 41.667h6.667" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle
      cx="11.667"
      cy="11.667"
      r="11.667"
      transform="matrix(-1 0 0 1 34.166 8.333)"
      fill="#fff"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      opacity=".4"
      d="M14.167 11.667c1.09.064 1.654.598 2.622 1.621 1.75 1.849 3.499 2.003 4.665 1.387 1.75-.924.28-2.421 2.332-3.235 1.339-.53 1.525-1.973.78-3.107m8.767 13.334c-2.5 0-2.943 2.078-5 1.666-4.166-.833-5.347.099-5.347 2.086 0 1.986 0 1.986-.867 3.477-.563.969-.76 1.938.363 2.77"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M20.833 36.667v5m-10-33.334c-3.085 3-5 7.18-5 11.805 0 9.128 7.462 16.529 16.667 16.529a16.69 16.69 0 0011.667-4.725"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default GlobeIcon;
